module.exports.phoneToLink = (phone) => {
  return `tel:${phone.replaceAll(/[^\d+]/g, '')}`;
}
